import { Steps, Box } from "@chakra-ui/react";
import React, { Children, forwardRef, ReactElement } from "react";

export const StepperRoot = forwardRef<
  React.ElementRef<typeof Steps.Root>,
  React.ComponentPropsWithoutRef<typeof Steps.Root>
>(({ className, variant, count, children, ...props }, ref) => {
  return (
    <Steps.Root ref={ref} variant={variant} key={variant} count={count} {...props}>
      {children}
    </Steps.Root>
  );
});

StepperRoot.displayName = "StepperRoot";

type StepsListElProps = {
  children?: React.ReactNode;
  unstyled?: boolean;
} & React.RefAttributes<HTMLDivElement>;

const StepsListEl = Steps.List as unknown as React.ForwardRefExoticComponent<StepsListElProps>;

type StepperListProps = {
  steps: Array<{ title: string; description?: string }>;
};

type StepsItemElProps = {
  index: number;
  title?: string;
  children?: React.ReactNode;
} & React.RefAttributes<HTMLDivElement>;

const StepsItemEl = Steps.Item as React.ForwardRefExoticComponent<StepsItemElProps>;

export const StepperListItems = forwardRef<
  React.ElementRef<typeof Steps.List>,
  React.ComponentPropsWithoutRef<typeof Steps.List> & StepperListProps
>(({ steps, ...props }, ref) => {
  return (
    <>
      <StepsListEl ref={ref}>
        {steps.map((step, index) => (
          <StepsItemEl key={index} index={index} title={step.title}>
            <Steps.Indicator />
            <Box maxWidth={"4/5"}>
              <Steps.Title>{step.title}</Steps.Title>
              <Steps.Description>{step.description}</Steps.Description>
            </Box>

            <Steps.Separator />
          </StepsItemEl>
        ))}
      </StepsListEl>
    </>
  );
});

StepperListItems.displayName = "StepperListItems";

type StepsContentWithChildrenProps = React.ComponentPropsWithoutRef<typeof Steps.Content> &
  React.RefAttributes<HTMLDivElement> & {
    index: number;
    children?: React.ReactNode;
  };

// const StepsContentEl = Steps.Content as React.FC<StepsContentWithChildrenProps>

// export const StepperContent = forwardRef<
// React.ElementRef<typeof Steps.Content>,
// StepsContentWithChildrenProps & { step : { title: string, description?:string} }
// >(({ index, step, ...props }, ref) => (
//     <>
//     <StepsContentEl ref={ref} index={index} {...props}>
//         { step.description }
//     </StepsContentEl>
//     </>
// ))

// StepperContent.displayName = "StepperContent"
